@if (!preventClick) {
  <a
    routerLink="/profile"
    class="position-relative d-block"
    (click)="profileClick.emit($event)"
    >
    <ng-template [ngTemplateOutlet]="picture"></ng-template>
  </a>
} @else {
  @if ((generalDataRepo.allGeneralData$ | async)?.activeUserData?.imagePath) {
    <div
      >
      <app-entity-avatar-init
      [img]="
        (generalDataRepo.allGeneralData$ | async)?.activeUserData?.imagePath
      "
      [name]="
        (generalDataRepo.allGeneralData$ | async)?.activeUserData?.userName
      "
      [surname]="
        (generalDataRepo.allGeneralData$ | async)?.activeUserData?.surname
      "
        [size]="160"
      ></app-entity-avatar-init>
    </div>
  }
  @if (!(generalDataRepo.allGeneralData$ | async)?.activeUserData?.imagePath) {
    <figure
      class="avatar avatar-160 rounded-circle mx-auto bg-secondary"
      [class.p-1px]="!(repo.image$ | async)"
      [class.avatar-160]="size === 'lg'"
      [class.mb-4]="size === 'lg'"
      [class.avatar-120]="size === 'md'"
      [class.mb-3]="size === 'md'"
      [class.avatar-36]="size === 'sm'"
      >
      <img
        [src]="(repo.image$ | async) || DEFAULT_IMAGE"
        [alt]="repo.displayName$ | async"
        />
      </figure>
    }
  }
  @if (size !== 'sm') {
    <div class="clearfix"></div>
    <h5
      class="position-relative"
      [class.h6]="size === 'md'"
      [class.mb-1]="size === 'md'"
      >
      @if (repo.displayName$ | async; as name) {
        {{
        name
        }}
      } @else {
        {{ repo.email$ | async }}
      }
    </h5>
    <p class="text-muted">{{ repo.roles$ | async | translateRoles | join }}</p>
  }
  <ng-template #picture>
    @if ((generalDataRepo.allGeneralData$ | async)?.activeUserData?.imagePath) {
      <div
        >
        <app-entity-avatar-init
      [img]="
        (generalDataRepo.allGeneralData$ | async)?.activeUserData?.imagePath
      "
      [name]="
        (generalDataRepo.allGeneralData$ | async)?.activeUserData?.userName
      "
      [surname]="
        (generalDataRepo.allGeneralData$ | async)?.activeUserData?.surname
      "
          [size]="160"
        ></app-entity-avatar-init>
      </div>
    }

    @if (!(generalDataRepo.allGeneralData$ | async)?.activeUserData?.imagePath) {
      <figure
        class="avatar avatar-160 rounded-circle mx-auto bg-secondary"
        [class.p-1px]="!(repo.image$ | async)"
        [class.avatar-160]="size === 'lg'"
        [class.mb-4]="size === 'lg'"
        [class.avatar-120]="size === 'md'"
        [class.mb-3]="size === 'md'"
        [class.avatar-36]="size === 'sm'"
        >
        <img
          [src]="(repo.image$ | async) || DEFAULT_IMAGE"
          [alt]="repo.displayName$ | async"
          />
        </figure>
      }
    </ng-template>
